var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8214 20.625H33.9286V14.2969C33.9286 13.5938 33.5938 12.832 33.0915 12.3047L27.567 6.50391C27.0647 5.97656 26.3393 5.625 25.6696 5.625H23.2143V2.8125C23.2143 1.28906 21.9866 0 20.5357 0H2.67857C1.17188 0 0 1.28906 0 2.8125V21.5625C0 23.1445 1.17188 24.375 2.67857 24.375H3.57143C3.57143 27.4805 5.97098 30 8.92857 30C11.8862 30 14.2857 27.4805 14.2857 24.375H21.4286C21.4286 27.4805 23.8281 30 26.7857 30C29.7433 30 32.1429 27.4805 32.1429 24.375H34.8214C35.2679 24.375 35.7143 23.9648 35.7143 23.4375V21.5625C35.7143 21.0938 35.2679 20.625 34.8214 20.625ZM8.92857 27.1875C7.42188 27.1875 6.25 25.957 6.25 24.375C6.25 22.8516 7.42188 21.5625 8.92857 21.5625C10.3795 21.5625 11.6071 22.8516 11.6071 24.375C11.6071 25.957 10.3795 27.1875 8.92857 27.1875ZM26.7857 27.1875C25.279 27.1875 24.1071 25.957 24.1071 24.375C24.1071 22.8516 25.279 21.5625 26.7857 21.5625C28.2366 21.5625 29.4643 22.8516 29.4643 24.375C29.4643 25.957 28.2366 27.1875 26.7857 27.1875ZM31.25 15H23.2143V8.4375H25.6696L31.25 14.2969V15Z",
    fill: "#575757"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.46c35a2f.svg";
export { ForwardRef as ReactComponent };